import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { HelpCircle, Send, ShoppingCart } from 'lucide-react';

export function AssistantFreeTextBar({
  visible,
  onAssistantHome,
  primaryColor,
  freeTextInput,
  setFreeTextInput,
  freeTextInputRef,
  onSubmitFreeText,
  onMainChoice,
  multilineCompose = false,
  dockRef,
  dockStyle,
}) {
  const [inputFocused, setInputFocused] = useState(false);

  if (!visible) return null;

  const placeholder = multilineCompose
    ? 'Pegá tu pedido acá (Enter para bajar de línea). Enviá con el botón →'
    : 'Escribe tu consulta (ej. horario, delivery, ingredientes)…';

  const showQuickActions = !onAssistantHome && !inputFocused;

  return (
    <div
      ref={dockRef}
      style={dockStyle}
      className="bg-background/98 backdrop-blur border-t shadow-lg pb-[max(0.5rem,env(safe-area-inset-bottom,0px))]"
    >
      <div className="max-w-4xl mx-auto px-3 sm:px-4 pt-1 pb-2">
        {showQuickActions ? (
          <div className="grid grid-cols-2 gap-2 pb-2">
            <Button
              variant="outline"
              className="h-auto py-2 justify-start gap-2"
              onClick={() => onMainChoice('order')}
              data-testid="main-option-order"
            >
              <ShoppingCart className="w-5 h-5 shrink-0" style={{ color: primaryColor }} />
              <span className="text-sm font-medium">Pedir</span>
            </Button>
            <Button
              variant="outline"
              className="h-auto py-2 justify-start gap-2"
              onClick={() => onMainChoice('question')}
              data-testid="main-option-question"
            >
              <HelpCircle className="w-5 h-5 shrink-0" style={{ color: primaryColor }} />
              <span className="text-sm font-medium">Una duda</span>
            </Button>
          </div>
        ) : null}
        <form
          className="flex gap-2 items-center py-0.5"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmitFreeText();
          }}
        >
          {multilineCompose ? (
            <Textarea
              ref={freeTextInputRef}
              value={freeTextInput}
              onChange={(e) => setFreeTextInput(e.target.value)}
              onFocus={() => setInputFocused(true)}
              onBlur={() => setInputFocused(false)}
              placeholder={placeholder}
              className="flex-1 text-sm min-h-[2.75rem] max-h-28 resize-none py-2 leading-snug sm:min-h-[4.5rem] sm:max-h-40"
              data-testid="assistant-free-text-input"
              autoComplete="off"
              rows={2}
            />
          ) : (
            <Input
              ref={freeTextInputRef}
              value={freeTextInput}
              onChange={(e) => setFreeTextInput(e.target.value)}
              onFocus={() => setInputFocused(true)}
              onBlur={() => setInputFocused(false)}
              placeholder={placeholder}
              className="flex-1 text-sm h-11"
              data-testid="assistant-free-text-input"
              autoComplete="off"
            />
          )}
          <Button
            type="submit"
            size="icon"
            className="shrink-0 h-11 w-11 text-white"
            style={{ backgroundColor: primaryColor }}
            data-testid="assistant-free-text-send"
            disabled={!freeTextInput.trim()}
            aria-label="Enviar consulta"
          >
            <Send className="w-4 h-4" />
          </Button>
        </form>
      </div>
    </div>
  );
}
